import _ from 'lodash';

import qconsole from 'scripts/lib/qconsole';
import RoutableCounts from 'models/routable_counts';
import { RoutingChannel, RoutingPreferenceGroup } from 'models/agent_routing_preferences';

export default class RoutableInboxCountsGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleFetchRoutableCountsSuccess(byRoutingGroup) {
    let routingGroups = this.context.stores.routingGroups.findAll();
    let currentAgentId = _.get(this.context.stores.currentAgent.get(), 'id');
    let matchingRoutingGroups = [];

    _.forEach(routingGroups, routingGroup => {
      if (_.includes(routingGroup.agentIds, currentAgentId)) {
        matchingRoutingGroups.push(routingGroup.id);
      }
    });

    let attrs = RoutableCounts.create().toJs();

    _.forEach(byRoutingGroup, (counts, rgId) => {
      if (_.includes(matchingRoutingGroups, rgId)) {
        attrs[RoutingPreferenceGroup.MESSAGING] += counts[RoutingChannel.MESSAGING];
        attrs[RoutingPreferenceGroup.VOICE] += counts[RoutingChannel.VOICE];
        const nonInteractiveCount = counts[RoutingChannel.MAIL] + (counts[RoutingChannel.TASK] || 0);
        attrs[RoutingPreferenceGroup.NON_INTERACTIVE] += nonInteractiveCount;
        attrs[RoutingPreferenceGroup.TASK] += counts[RoutingChannel.TASK];
      }
    });
    this.context.stores.routableCounts.set(RoutableCounts.fromJs(attrs));
  }

  handleFetchRoutableCountsError(errorDto) {
    qconsole.log(`Failed to fetch routable inbox counts ${JSON.stringify(errorDto)}`);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/routable_inbox_counts_gateway_observer.js